export default function WelcomeSection() {
  return (
    <div
      className="relative min-h-[310px] w-full bg-white bg-[url('/images/catalyst-light-bg-stoner-mobile-optimized.webp')] bg-cover bg-center bg-no-repeat py-8"
      data-debug="welcome-section-loaded"
    >
      <div className="container mx-auto px-4">
        <div className="flex min-h-[230px] flex-col items-center space-y-6">
          {/* Foreground Image Section */}
          <div className="relative z-10 flex min-h-[150px] w-full justify-center">
            <img
              src="/images/welcome-to-catalyst-california-dispensaries.webp"
              alt="Welcome to Catalyst California Dispensaries - Premium cannabis products"
              className="h-auto w-full max-w-[556px] object-contain"
              loading="eager"
              decoding="sync"
              {...({ fetchpriority: 'high' } as any)}
              width="556"
              height="300"
            />
          </div>

          {/* Secondary Image Section (optional) */}
          <div className="z-10 flex min-h-[44px] w-full justify-center py-6">
            <div className="flex h-8 w-[374px] items-center justify-center">
              <img
                src="/logos/WFTP.webp"
                alt="WFTP - Weed For The People logo"
                className="h-8 w-[374px] object-contain"
                loading="eager"
                decoding="sync"
                {...({ fetchpriority: 'high' } as any)}
                width="374"
                height="32"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
